import React, {useEffect, useState} from 'react';
import {makeRequest} from "../../utils/httpRequest";
import DatePicker from "react-datepicker";
import Config from "../../core/config";
import {
    formatDateTimeToString, formatDateToString,
    formatLocalDate,
    
    parseLocalDate,
    UserPermission
} from "../../utils/utils";
import {
    findCompaniesByQueryString,
    getAllPaymentMethods,
    getReceivableById,
    getCustomerById
} from "../../utils/requestUtils";
import ConfirmButton from "../common/ConfirmButton";
import ActionButtonsManagerView from "../common/ActionButtonsManagerView";
import CustomerSelectAsync from "../customer/CustomerSelectAsync";
import DecimalInput from "../common/DecimalInput";

import Cookies from "js-cookie";
import {useNavigate} from "react-router-dom";
import Loading from "../../core/Loading";
import {loadingAtom} from "../../atoms";
import {useRecoilState} from "recoil";
import {usePermission} from "../../core/PermissionContext";

const apiUrl = Config.apiUrl;

const ReceivableManager = (props) => {
    const { hasUserPermission, loadingPermissions } = usePermission();
    const [paymentMethods, setPaymentMethods] = useState([]);
    const [companies, setCompanies] = useState([]);

    const navigate = useNavigate();
    const searchParams = new URLSearchParams(window.location.search);
    const id = searchParams.get('id');

    const newEntity = {
        id: undefined,
        customerCompany: undefined,
        customer: undefined,
        customerName: '',
        description: '',
        value: 0.0,
        baseValue: 0.0,
        feeAmount: 0.0,
        date: new Date(),
        dueDate: formatLocalDate(new Date()),
        paymentDate: undefined,
        status: 0,
    };
    const [formData, setFormData] = useState(newEntity);
    const [repeatValue, setRepeatValue] = useState(1);
    const [repeat, setRepeat] = useState(false);

    const handleChange = (e) => {
        const {name, value, type, checked} = e.target;

        if (name === 'baseValue') {
            const baseValue = parseFloat(value) || 0;
            const feePercentage = formData.paymentMethod?.fee || 0;
            const feeAmount = (baseValue * feePercentage) / 100;
            const totalValueWithFee = baseValue + feeAmount;
            
            setFormData((prevData) => ({
                ...prevData,
                value: totalValueWithFee,
                baseValue: value,
                feeAmount: feeAmount
            }));
        } else {
            setFormData((prevData) => ({
                ...prevData,
                [name]: type === 'checkbox' ? checked : value
            }));
        }
    };

    const handleRepeatValueChange = (e) => {
        const {value} = e.target;
        if (value <= 0 || value > 12) {
            return;
        }
        setRepeatValue(value);
    };

    const handleRepeatChange = (e) => {
        const {checked} = e.target;
        setRepeat(checked);
        setRepeatValue(!checked ? 1 : 2);
    };

    const handleBirthDateChange = (date) => {
        setFormData((prevData) => ({
            ...prevData,
            ['birthDate']: date
        }));
    };

    const handleKidBirthDateChange = (date) => {
        setFormData((prevData) => ({
            ...prevData,
            ['kidBirthDate']: date
        }));
    };

    const [loading, setLoading] = useRecoilState(loadingAtom);

    async function makeQuery() {
        if (id) {
            try {
                const response = await getReceivableById(id);
                setFormData(response);
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        } else {
            setFormData(newEntity);
        }
    }

    useEffect(() => {
        makeQuery();
    }, [id]);

    useEffect(() => {
        getAllPaymentMethods().then((p) => setPaymentMethods(p));
    }, []);

    function clearEntity() {
        setFormData(newEntity);
    }

    const onConfirm = async () => {

        try {
            if (validateInputs()) {

                await new Promise(resolve => setTimeout(resolve, 300));
                if(id) {
                    formData.id = id;
                    await saveEntity(formData);
                } else {
                    const [year, month, day] = formData.dueDate.split('-');
                    const initialDueDate = new Date(year, month - 1, day);

                    for (let i = 0; i < repeatValue; i++) {
                        let currentDueDate = new Date(initialDueDate);
                        currentDueDate.setMonth(currentDueDate.getMonth() + i);

                        formData.dueDate = formatLocalDate(currentDueDate);
                        await saveEntity(formData);
                    }
                }
                clearEntity();
                navigate('/app/receivablelist');
            }
        } catch (error) {
            console.error('Error saving:', error);
            alert('Error ao salvar.');
        } finally {

        }
    };

    function validateInputs() {

        if (hasUserPermission(UserPermission.ENABLE_CUSTOMER_SELECTION_IN_RECEIVABLE_MANAGER)) {
            if (!formData.customer) {
                alert('Selecione um cliente.');
                return false;
            }
        } else if (!hasUserPermission(UserPermission.ENABLE_CUSTOMER_COMPANY_IN_RECEIVABLE_MANAGER) && !formData.customerName) {
            alert('Preencha o campo nome do cliente.');
            return false;
        }

        if(hasUserPermission(UserPermission.ENABLE_CUSTOMER_COMPANY_IN_RECEIVABLE_MANAGER) && !formData.customerCompany) {
            alert('Selecione uma empresa.');
            return false;
        }
        if (!formData.description || formData.description === '') {
            alert('Preencha o campo descrição.');
            return false;
        }

        if (!formData.value || formData.value === 0) {
            alert('Preencha o campo valor.');
            return false;
        }

        if (!formData.date || formData.date === '') {
            alert('Preencha o campo data de lançamento.');
            return false;
        }

        if (!formData.dueDate || formData.dueDate === '') {
            alert('Preencha o campo data de vencimento.');
            return false;
        }

        if(formData.paymentDate && !formData.paymentMethod) {
            alert('Preencha o campo forma de pagamento.');
            return false;
        }
        return true;
    }

    async function saveEntity(entity) {
        const url = apiUrl + '/api/receivables';
        setLoading(true);
        await makeRequest(url, id ? 'PUT' : 'POST', {
            'Content-Type': 'application/json',
            'Useruuid':Cookies.get('userUUID')
        }, JSON.stringify(entity));
        setLoading(false);
    }

    async function handleDateChange(date, field) {
        setFormData((prevData) => ({
            ...prevData,
            [field]:
                formatLocalDate(date)
        }));
    }

    function handlePaymentMethodSelected(id) {

        if(id) {
            const paymentMethod = paymentMethods.find((p) => p.id === Number(id));
            const currentValue = formData.baseValue || 0;
            const feePercentage = paymentMethod?.fee || 0;
            const feeAmount = (currentValue * feePercentage) / 100;
            const totalValueWithFee = currentValue + feeAmount;
            
            setFormData((prevData) => ({
                ...prevData,
                paymentMethod: paymentMethod,
                value: totalValueWithFee,
                baseValue: currentValue,
                feeAmount: feeAmount
            }));
        }
    }

    function handleCustomerCompanySelected(id) {

        if(id) {
            const customerCompany = companies.find((p) => p.id === Number(id));
            setFormData((prevData) => ({
                ...prevData,
                customerCompany: customerCompany
            }));
        }
    }

    async function selectCustomer(id) {
        const customer = await getCustomerById(id);
        setFormData((prevData) => ({
            ...prevData,
            customer: customer
        }));
    }

    const handleCustomerItemClick = async (id) => {
        await selectCustomer(id);
    };



    if(loadingPermissions) {
        return <Loading/>
    }

    if(hasUserPermission(UserPermission.CREATE_RECEIVABLE) === false || (hasUserPermission(UserPermission.EDIT_RECEIVABLE) === false && id)) {
        navigate('/unauthorizedaccess');
    }

    if(hasUserPermission(UserPermission.ENABLE_CUSTOMER_COMPANY_IN_RECEIVABLE_MANAGER)) {
        findCompaniesByQueryString('').then((p) => setCompanies(p))
    }

    return (
        <div style={{width: '300px'}}>

            <div className="header-label">{formData.id > 0 ? 'Editar' : 'Cadastrar'} Recebimento</div>

            {hasUserPermission(UserPermission.ENABLE_CUSTOMER_COMPANY_IN_RECEIVABLE_MANAGER) && companies && (
                <div style={{marginTop: '5px', alignItems: 'center'}}>
                    <div style={{width: '180px'}}>Empresa:</div>
                    <select value={formData.customerCompany ? formData.customerCompany.id : undefined}
                            onChange={(e) => handleCustomerCompanySelected(e.target.value)}>
                        <option value={undefined}>Selecione uma Empresa</option>
                        {companies.map((customerCompany, index) => (
                            <option key={index} value={customerCompany.id}>
                                {customerCompany.name}
                            </option>
                        ))}
                    </select>
                </div>
            )}

            {hasUserPermission(UserPermission.ENABLE_CUSTOMER_SELECTION_IN_RECEIVABLE_MANAGER) && (
                <div style={{marginTop: '5px', alignItems: 'center'}} data-test="customer-selection-field">
                    <div style={{width: '180px'}}>Cliente:</div>
                    <CustomerSelectAsync 
                        onItemClick={handleCustomerItemClick}
                        style={{width: '300px'}}
                        placeholder="Selecione um cliente..."
                        value={formData.customer && formData.customer.id ? formData.customer.id : null}
                        prefilledCustomer={formData.customer}
                    />
                </div>
            )}

            {!hasUserPermission(UserPermission.ENABLE_CUSTOMER_SELECTION_IN_RECEIVABLE_MANAGER) && !hasUserPermission(UserPermission.ENABLE_CUSTOMER_COMPANY_IN_RECEIVABLE_MANAGER) && (
                <div style={{marginTop: '5px', alignItems: 'center'}}>
                    <div style={{width: '180px'}}>Nome do Cliente:</div>
                    <input type="text" style={{width: '300px'}} value={formData.customerName} name="customerName"
                           onChange={handleChange}/>
                </div>
            )}
            <div style={{marginTop: '5px', alignItems: 'center'}}>
                <div style={{width: '180px'}}>Descrição:</div>
                <input type="text" style={{width: '300px'}} value={formData.description} name="description"
                       onChange={handleChange} data-test="description-input"/>
            </div>
            <div style={{marginTop: '5px', alignItems: 'center'}}>
                <div style={{width: '180px'}}>Forma de Pagamento:</div>
                <select value={formData.paymentMethod ? formData.paymentMethod.id : undefined}
                        onChange={(e) => handlePaymentMethodSelected(e.target.value)}>
                    <option value={undefined}>Selecione uma Forma de Pagamento</option>
                    {paymentMethods.map((paymentMethod, index) => (
                        <option key={index} value={paymentMethod.id}>
                            {paymentMethod.name}
                        </option>
                    ))}
                </select>
            </div>


            <div style={{marginTop: '5px', alignItems: 'center'}}>
                <div style={{width: '180px'}}>Valor:</div>
                <DecimalInput
                    style={{width: '100px'}}
                    placeholder="0,00"
                    value={formData.baseValue || formData.value}
                    name="baseValue"
                    onChange={handleChange}
                    data-test="value-input"/>
                {formData.paymentMethod?.fee > 0 && (
                    <div style={{marginLeft: '10px', fontSize: '12px', color: '#666'}}>
                        Taxa: {formData.paymentMethod.fee}% (+R$ {formData.feeAmount?.toFixed(2) || '0.00'})
                    </div>
                )}
            </div>
            {formData.paymentMethod?.fee > 0 && (
                <div style={{marginTop: '5px', alignItems: 'center'}}>
                    <div style={{width: '180px'}}>Valor Total:</div>
                    <span style={{fontWeight: 'bold', color: '#333'}}>
                        R$ {formData.value?.toFixed(2) || '0.00'}
                    </span>
                </div>
            )}

            <div style={{marginTop: '5px', alignItems: 'center'}}>
                <div style={{width: '180px'}}>Data de Lançamento:</div>
                <input
                    disabled
                    type="text"
                    style={{width: '130px'}}
                    value={formatDateTimeToString(new Date(formData.date))}
                />
            </div>

            <div style={{marginTop: '5px', alignItems: 'center'}}>
                <div style={{width: '180px'}}>Data de Vencimento:</div>
                <DatePicker
                    className="datepicker"
                    dateFormat="dd/MM/yyyy"
                    data-test="due-date-picker"
                    selected={formData.dueDate ? parseLocalDate(formData.dueDate) : undefined}
                    onChange={(date) => handleDateChange(date, 'dueDate')}
                    isClearable
                    autoComplete="off"
                />
            </div>


            <div style={{marginTop: '5px', alignItems: 'center'}}>
                <div style={{width: '180px'}}>Data de Pagamento:</div>
                <DatePicker
                    className="datepicker"
                    dateFormat="dd/MM/yyyy"
                    selected={formData.paymentDate ? parseLocalDate(formData.paymentDate) : undefined}
                    onChange={(date) => handleDateChange(date, 'paymentDate')}
                    isClearable
                    data-test="payment-date-picker"
                    autoComplete="off"
                />
            </div>
            {!id &&
                <div style={{marginTop: '5px', alignItems: 'center'}}>
                    <div style={{display: 'flex', alignItems: 'center'}}>
                        <input type="checkbox" checked={repeat}
                               onChange={handleRepeatChange}/>
                        <div>Repetir?</div>
                    </div>
                    <div style={{display: 'flex', alignItems: 'center'}}>
                        <input type="number"
                               style={{width: '100px'}}
                               disabled={!repeat}
                               min={2}
                               max={12}
                               step="1" placeholder="0"
                               value={repeatValue}
                               onChange={handleRepeatValueChange}/>
                        <div> (meses)</div>
                    </div>
                </div>
            }
            <ActionButtonsManagerView>
                <ConfirmButton onClick={onConfirm} data-test="confirm-button"/>
            </ActionButtonsManagerView>


        </div>
    );
};

export default ReceivableManager;
